import React from 'react';
import { Link } from 'react-router-dom';
import MsRubiesBadge from './MsRubiesBadge';

export default function Footer() {
    return (
        <footer className="border-t border-white/10 bg-brand-surface2 mt-16">
            <div className="max-w-7xl mx-auto px-5 lg:px-10 py-14 grid md:grid-cols-2 lg:grid-cols-4 gap-10">
                <div>
                    <div className="flex items-center gap-2 mb-4">
                        <i className="fa-solid fa-anchor text-brand-aqua"></i>
                        <span className="font-display text-xl font-extrabold uppercase tracking-tight">
                            Cruise <span className="font-serif-italic font-medium text-brand-gold">Vibes</span>
                        </span>
                    </div>
                    <p className="text-sm text-white/60 max-w-xs">We don't just book cruises... we create unforgettable experiences. Luxury vacations, exclusive parties, VIP concierge.</p>
                    <div className="mt-5">
                        <MsRubiesBadge variant="pill" />
                    </div>
                </div>
                <div>
                    <h4 className="text-xs uppercase tracking-[0.2em] text-brand-aqua mb-4">Explore</h4>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li><Link to="/upcoming" className="hover:text-white">Upcoming Events</Link></li>
                        <li><Link to="/party" className="hover:text-white">Party Cruises</Link></li>
                        <li><Link to="/reviews" className="hover:text-white">Reviews</Link></li>
                        <li><Link to="/gallery" className="hover:text-white">Gallery</Link></li>
                    </ul>
                </div>
                <div>
                    <h4 className="text-xs uppercase tracking-[0.2em] text-brand-aqua mb-4">Contact</h4>
                    <ul className="space-y-2 text-sm text-white/70">
                        <li><i className="fa-solid fa-phone mr-2 text-brand-gold"></i> <a href="tel:+16029354489" className="hover:text-white">602-935-4489</a></li>
                        <li><i className="fa-solid fa-envelope mr-2 text-brand-gold"></i> <a href="mailto:rubiesglobalservices@gmail.com" className="hover:text-white">rubiesglobalservices@gmail.com</a></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/5 py-5 text-center text-xs text-white/40">
                © {new Date().getFullYear()} Cruise Vibes Travel Co. — Charted with passion.
            </div>
        </footer>
    );
}
